var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.997,
    viewBox: "0 0 18 17.997",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.261,8.747,18.31,7.23,17.146,4.42l-2.522.375a6.9,6.9,0,0,0-.8-.8L14.2,1.476,11.393.312,9.874,2.361a7.046,7.046,0,0,0-1.126,0L7.229.312,4.419,1.476,4.795,4a6.815,6.815,0,0,0-.8.8l-2.52-.376L.312,7.23,2.36,8.747a7.058,7.058,0,0,0,0,1.127L.312,11.392,1.476,14.2,4,13.826a6.9,6.9,0,0,0,.8.8L4.42,17.145l2.81,1.164,1.518-2.048a6.811,6.811,0,0,0,1.126,0l1.52,2.049,2.81-1.164-.376-2.522a6.9,6.9,0,0,0,.8-.8l2.521.375,1.164-2.81L16.264,9.873A7.3,7.3,0,0,0,16.261,8.747Zm.155,4.168-2.29-.341-.208.272a5.814,5.814,0,0,1-1.071,1.069l-.273.209.342,2.291-1.129.468-1.38-1.861-.34.046a5.791,5.791,0,0,1-1.514,0l-.34-.046-1.379,1.86-1.129-.468.341-2.29-.273-.209A5.814,5.814,0,0,1,4.7,12.846L4.5,12.574l-2.29.342-.468-1.129L3.6,10.408l-.046-.341a5.82,5.82,0,0,1,0-1.512L3.6,8.214,1.737,6.835l.468-1.129,2.29.341L4.7,5.775A5.814,5.814,0,0,1,5.775,4.706L6.048,4.5,5.706,2.2l1.129-.468L8.215,3.6l.34-.045a5.828,5.828,0,0,1,1.513,0l.34.045,1.379-1.86,1.129.468-.341,2.29.273.209a5.814,5.814,0,0,1,1.069,1.071l.208.272,2.291-.341.468,1.129L15.023,8.214l.045.341a5.828,5.828,0,0,1,0,1.513l-.046.341,1.861,1.379Z",
    transform: "translate(-0.312 -0.312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.214,5.285a3.8,3.8,0,1,0,3.8,3.8A3.8,3.8,0,0,0,9.214,5.285Zm0,6.444a2.639,2.639,0,1,1,2.639-2.639A2.642,2.642,0,0,1,9.214,11.729Z",
    transform: "translate(-0.13 -0.134)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settings.5305efc26f46d7584ca49f3e432935a1.svg";